export default "__VITE_ASSET__C7NUN5Xa__"